import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { DrawCreateComponent } from '@modules/draw/draw-create/draw-create.component';
import { DrawListComponent } from '@modules/draw/draw-list/draw-list.component';
import { NgLeafletUniversalModule } from 'ng-leaflet-universal';
import { NgxMaskModule } from 'ngx-mask';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DownloadsComponent } from './core/modules/downloads/downloads.component';
import { EventsComponent } from './core/modules/events/events.component';
import { HttpInterceptorProviders } from './core/shared/guard/app-interceptor.service';
import { SharedModule } from './core/shared/shared.module';
import { StepParameterizationModule } from '@modules/competition/step-parameterization/step-parameterization.module';
import { EditStatesComponent } from './core/modules/states/edit-states/edit-states.component';
import { StatesComponent } from './core/modules/states/states.component';
import { CitiesComponent } from './core/modules/cities/cities.component';
import { GamesTableComponent } from '@modules/competition/games-table/games-table.component';



@NgModule({
  declarations: [
    AppComponent,
    EventsComponent,
    DownloadsComponent,
    DrawListComponent,
    DrawCreateComponent,
    EditStatesComponent,
    StatesComponent,
    CitiesComponent,
  ],
  imports: [
    NgLeafletUniversalModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    NgxMaskModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    StepParameterizationModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [HttpInterceptorProviders],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    // Add multiple icons to the library
    library.addIconPacks(fas, far);
  }
}
